import { orderReference } from "./orderReference";
import { contractDate } from "./planningDates";
export function planningOrders(orders) {
  return orders.flatMap(order => {
    if (/^(annul|termin)/.test(String(order.status || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase())) return [];
    const filled = new Set([...(order.confirmedCandidates || []), ...(order.contractedCandidates || [])].map(candidate => candidate?._id || candidate).filter(Boolean).map(String));
    const remaining = Math.max(0, Number(order.quantity || 0) - filled.size);
    if (!remaining) return [];
    const periods = order.dateRanges?.length ? order.dateRanges : order.selectedDates?.length ? order.selectedDates.map(date => ({startDate:date,endDate:date})) : order.dates?.length ? order.dates.map(date => ({startDate:date,endDate:date})) : [{startDate:order.startDate,endDate:order.endDate || order.startDate}];
    return periods.filter(period => contractDate(period.startDate)).map((period,index) => ({
      _id:`order-${order._id}-${index}`, isOpenPosition:true, orderId:order._id,
      contractType:order.contractType || order.typeContrat || order.TypeContrat,
      IdClient:order.client?._id || order.client,
      RaisonSociale:order.client?.companyName || order.companyName || order.clientName || "Client",
      NomPrenom:`${order.qualification || "Poste"} · ${remaining} à pourvoir`,
      DateDebut:period.startDate, DateFin:period.endDate || period.startDate,
      HeureDebut:period.startHour || order.startHour, HeureFin:period.endHour || order.endHour,
      workedDays:order.workedDays || [], NumeroContrat:orderReference(order), remaining, Qualification:order.qualification || "Poste",
    }));
  });
}

// A confirmed person is scheduled immediately, before the contract is prepared.
export function confirmedPlanningOrders(orders, contracts = []) {
  return orders.flatMap(order => {
    if (/^(annul|termin)/.test(String(order.status || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase())) return [];
    const periods = order.dateRanges?.length ? order.dateRanges : order.selectedDates?.length
      ? order.selectedDates.map(date => ({ startDate: date, endDate: date }))
      : [{ startDate: order.startDate, endDate: order.endDate || order.startDate }];
    return (order.confirmedCandidates || []).filter(candidate => candidate?._id).flatMap(candidate => periods.filter(period => contractDate(period.startDate) && !contracts.some(contract => {
      const exact = String(contract.order?._id || contract.order || '') === String(order._id) &&
        String(contract.candidate?._id || contract.candidate || '') === String(candidate._id);
      const synapse = candidate.pld != null && order.client?.pld != null &&
        String(contract.IdInterimaire) === String(candidate.pld) && String(contract.IdClient) === String(order.client.pld) &&
        String(contract.Qualification || contract.TxtQualification || '') === String(order.qualification || '');
      if (!exact && !synapse) return false;
      const start = contractDate(contract.DateDebut || contract.startDate);
      const end = contractDate(contract.DateFinMission || contract.DateFin || contract.endDate) || start;
      return !start || (start <= contractDate(period.startDate) && end >= contractDate(period.endDate || period.startDate));
    })).map((period, index) => ({
      _id: `confirmed-${order._id}-${candidate._id}-${index}`, isConfirmedPosition: true, orderId: order._id,
      contractType: order.contractType || order.typeContrat, candidate: candidate._id, IdInterimaire: candidate._id,
      IdClient: order.client?._id || order.client, RaisonSociale: order.client?.companyName || order.clientName || 'Client',
      NomPrenom: [candidate.firstname, candidate.lastname].filter(Boolean).join(' '),
      Qualification: order.qualification, NumeroContrat: orderReference(order), status: 'Confirmé',
      DateDebut: period.startDate, DateFin: period.endDate || period.startDate,
      HeureDebut: period.startHour || order.startHour, HeureFin: period.endHour || order.endHour,
      workedDays: order.workedDays || [],
    })));
  });
}
